<template>
  <div class="row">
    <div class="col-12 col-md-10 mx-auto">
      <div class="d-flex flex-row justify-content-between w-100">
        <div class="d-flex flex-column my-auto">
          <span
            v-if="email"
            class="text-muted small"
          >{{ email }}</span>
        </div>
        <div class="d-flex my-auto">
          <span
            class="badge badge-pill"
            :class="[
              `bg-${displayStatus.color}`,
              { 'text-blue-700': displayStatus.color === 'yellow-400'}
            ]"
          >
            <span class="mx-1">
              {{ displayStatus.text }}
            </span>
          </span>
        </div>
        <div
          v-if="['PENDING', 'IN_PROGRESS'].includes(status)"
          class="d-flex my-auto"
        >
          <v-loader
            title="Relancer"
            :next="resendInvitation"
            color="blue-400"
            class="text-white ms-2"
          />
        </div>
      </div>
      <hr
        v-if="!isLast"
        class="w-100"
      >
    </div>
  </div>
</template>
<script>
import { ui } from '@/mixins';

export default {
  mixins: [ui],
  props: {
    codePromo: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: 'PENDING',
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statuses: {
        IN_PROGRESS: {
          text: 'En attente',
          color: 'yellow-400',
          icon: 'clock',
        },
        PENDING: {
          text: 'En attente',
          color: 'yellow-400',
          icon: 'clock',
        },
        COMPLETE: {
          text: 'Validé',
          color: 'green-600',
          icon: 'check-circle',
        },
        CONSUME: {
          text: 'Cagnotte utilisée',
          color: 'green-600',
          icon: 'check-circle',
        },
      },
    };
  },
  computed: {
    displayStatus() {
      return this.statuses[this.status]
        || this.statuses.PENDING;
    },
  },
  methods: {
    async resendInvitation() {
      const { id, firstName, lastName } = this;
      await this.$store.dispatch('sponsorship/setValue', {
        current: { id, firstName, lastName },
      });
      await this.$store.dispatch('sponsorship/resendEmail');
    },
  },
};
</script>
